import { selectCurrentUser } from '@/store/features/users/current-user.slice';
import { PostHogEventMap } from '@/utils/posthog';
import { usePostHog } from 'posthog-js/react';
import { useMemo } from 'react';
import { useAppSelector } from './store';

/**
 * Hook to handle PostHog tracking with respect to allowPosthogTracking property
 */
export const usePosthogTracking = () => {
  const posthog = usePostHog();
  const user = useAppSelector(selectCurrentUser);

  const allowTracking = useMemo(() => {
    if (!user) {
      return false;
    }

    return user?.account?.allowPosthogTracking ?? false;
  }, [user]);

  const trackPostHogEvent = <T extends keyof PostHogEventMap>(
    event: T,
    properties?: PostHogEventMap[T],
  ) => {
    if (!allowTracking) {
      return;
    }

    posthog.capture(event, properties);
  };

  const trackPostHogEventWithAllowTracking = <T extends keyof PostHogEventMap>(
    event: T,
    properties?: PostHogEventMap[T],
  ) => {
    posthog.capture(event, properties);
  };

  return {
    allowTracking,
    trackPostHogEvent,
    trackPostHogEventWithAllowTracking,
  };
};
